import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=b6a35492&scoped=true&"
import script from "./dialogComponent.vue?vue&type=script&lang=js&"
export * from "./dialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./dialogComponent.vue?vue&type=style&index=0&id=b6a35492&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a35492",
  null
  
)

export default component.exports